// assets/js/hooks/textarea_autogrow.js
export default {
  mounted() {
    this.el.addEventListener('input', () => this.resize())
    requestAnimationFrame(() => this.resize())
  },

  updated() {
    this.resize()
  },

  resize() {
    const el = this.el

    // Reset height to auto to get the correct scrollHeight
    el.style.height = 'auto'

    // Set to scrollHeight to expand the textarea
    el.style.height = el.scrollHeight + 'px'

    // Add a small buffer for better UX
    el.style.overflow = 'hidden'
  },
}
